import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { text } from '../text';
import { components } from '../components';

// const privacyPolicy = [
//   {
//     id: 1,
//     title: '1. Terms',
//     content:
//       'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
//   },
//   {
//     id: 2,
//     title: '2. Use license',
//     content:
//       'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
//   },
//   {
//     id: 3,
//     title: '3. Disclaimer',
//     content:
//       'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
//   },
// ];


const privacyPolicy = [
  {
    id: 1,
    title: '1. Introduction',
    content:
      'We value your privacy and are committed to protecting your personal data. This Privacy Policy outlines how we collect, use, and safeguard your information when you use our PG booking platform.',
  },
  {
    id: 2,
    title: '2. Information We Collect',
    content:
      'We may collect personal details including your name, contact number, email, gender, and location preferences when you use our services. We may also collect location data (with your permission) to show PGs near you.',
  },
  {
    id: 3,
    title: '3. How We Use Your Information',
    content:
      'We use your data to provide personalized PG recommendations, communicate booking-related information, improve user experience, and send important service-related updates. Your information is never sold to third parties.',
  },
  {
    id: 4,
    title: '4. Sharing of Information',
    content:
      'We may share your data with PG owners or partners solely for the purpose of booking or inquiry. We do not share your personal information for any marketing or unrelated third-party services.',
  },
  {
    id: 5,
    title: '5. Cookies and Tracking',
    content:
      'We use cookies to enhance your browsing experience and gather analytics to improve our platform. You may choose to disable cookies via your browser settings, though this may affect functionality.',
  },
  {
    id: 6,
    title: '6. Security',
    content:
      'We implement appropriate technical and organizational measures to protect your data from unauthorized access, alteration, disclosure, or destruction.',
  },
  {
    id: 7,
    title: '7. Your Rights',
    content:
      'You have the right to access, correct, or delete your personal information at any time. You may also request that we stop using your data for certain purposes.',
  },
  {
    id: 8,
    title: '8. Changes to This Policy',
    content:
      'We may update this Privacy Policy periodically. We encourage you to review this page from time to time for any changes.',
  },
  {
    id: 9,
    title: '9. Contact Us',
    content:
      'If you have any questions or concerns about this Privacy Policy or how your data is handled, please contact us at support@yourpgplatform.com.',
  },
];


export const PrivacyPolicy: React.FC = () => {
  const location = useLocation();
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };

    scrollToTop();
  }, [pathname]);

  const renderImageBackground = (): JSX.Element => {
    return <components.Background version={1} />;
  };

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title='Privacy Policy'
        goBack={true}
      />
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main
        className='container'
        style={{ paddingBottom: 0 }}
      >
        <div style={{ marginTop: '10%', marginBottom: 20 }}>
          {privacyPolicy.map((item) => {
            return (
              <div
                style={{ marginBottom: '10%' }}
                key={item.id}
              >
                <text.H5 style={{ marginBottom: 10 }}>{item.title}</text.H5>
                <text.T14>{item.content}</text.T14>
              </div>
            );
          })}
        </div>
      </main>
    );
  };

  return (
    <>

      {renderHeader()}
      {renderContent()}
    </>
  );
};
